import React, { useState } from 'react';
import styled from 'styled-components';

interface Club {
  name: string;
  stripeUrl: string;
}

const clubs: Club[] = [
  { name: 'AD Ceuta FC', stripeUrl: 'https://buy.stripe.com/3cI28rfBj6clanG6m897G06' },
  { name: 'Albacete Balompié', stripeUrl: 'https://buy.stripe.com/14AbJ10GpgQZeDWh0M97G07' },
  { name: 'Burgos CF', stripeUrl: 'https://buy.stripe.com/dRmdR94WF44dbrK8ug97G08' },
  { name: 'Cadiz CF', stripeUrl: 'https://buy.stripe.com/eVq28r9cV8kt67qaCo97G05' },
  { name: 'CD Castellón', stripeUrl: 'https://buy.stripe.com/6oUeVd60J6cldzSh0M97G09' },
  { name: 'CD Leganés', stripeUrl: 'https://buy.stripe.com/28E5kDagZdENanGcKw97G04' },
  { name: 'CD Mirandés', stripeUrl: 'https://buy.stripe.com/8x24gz9cVfMV9jC5i497G0a' },
  { name: 'Córdoba CF', stripeUrl: 'https://buy.stripe.com/8x23cv74NfMVeDWh0M97G0b' },
  { name: 'Cultural y Deportiva Leonesa', stripeUrl: 'https://buy.stripe.com/9B69AT2OxasB2VeaCo97G0c' },
  { name: 'FC Andorra', stripeUrl: 'https://buy.stripe.com/3cI9ATfBjbwFfI04e097G0d' },
  { name: 'Granada CF', stripeUrl: 'https://buy.stripe.com/8x26oHagZ309cvOfWI97G0e' },
  { name: 'Málaga CF', stripeUrl: 'https://buy.stripe.com/cNi3cvfBj9oxcvOh0M97G0f' },
  { name: 'Real Club Deportivo de la Coruña', stripeUrl: 'https://buy.stripe.com/8x28wP3SB8kt0N65i497G0g' },
  { name: 'Real Racing Club', stripeUrl: 'https://buy.stripe.com/bJe00j1Kt8kt67q6m897G0h' },
  { name: 'Real Sociedad de Fútbol', stripeUrl: 'https://buy.stripe.com/9B6bJ188R0S1cvObGs97G0i' },
  { name: 'Real Sporting de Gijón', stripeUrl: 'https://buy.stripe.com/9B600jcp7eIRfI09yk97G0j' },
  { name: 'Real Valladolid CF', stripeUrl: 'https://buy.stripe.com/fZu7sL3SB8kt2Ve8ug97G0k' },
  { name: 'Real Zaragoza', stripeUrl: 'https://buy.stripe.com/5kQ4gzfBj0S12VefWI97G0l' },
  { name: 'SD Eibar', stripeUrl: 'https://buy.stripe.com/5kQ3cvagZ9oxdzS25S97G0m' },
  { name: 'SD Huesca', stripeUrl: 'https://buy.stripe.com/3cI7sLbl37gp1RafWI97G0n' },
  { name: 'UD Almería', stripeUrl: 'https://buy.stripe.com/bJe3cv9cV309fI04e097G0o' },
  { name: 'UD Las Palmas', stripeUrl: 'https://buy.stripe.com/fZu28ragZ6cl7bu4e097G0p' }
];

interface SubscriptionModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const ModalOverlay = styled.div<{ isOpen: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  display: ${props => props.isOpen ? 'flex' : 'none'};
  justify-content: center;
  align-items: center;
  z-index: 1000;
  padding: 20px;
`;

const ModalContent = styled.div`
  background: linear-gradient(135deg, rgba(20, 30, 48, 0.95), rgba(36, 59, 85, 0.95));
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 20px;
  padding: 40px;
  max-width: 500px;
  width: 100%;
  max-height: 80vh;
  overflow-y: auto;
  backdrop-filter: blur(20px);
  position: relative;
  
  @media (max-width: 768px) {
    padding: 30px;
    max-width: 90vw;
  }
`;

const CloseButton = styled.button`
  position: absolute;
  top: 15px;
  right: 20px;
  background: none;
  border: none;
  color: rgba(255, 255, 255, 0.7);
  font-size: 24px;
  cursor: pointer;
  transition: color 0.2s ease;
  
  &:hover {
    color: white;
  }
`;

const ModalTitle = styled.h2`
  font-family: 'CocomatPro', sans-serif;
  font-size: 28px;
  font-weight: bold;
  color: white;
  text-align: center;
  margin: 0 0 30px 0;
  text-transform: uppercase;
  letter-spacing: 1px;
`;

const ClubSelector = styled.select`
  width: 100%;
  padding: 15px;
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 10px;
  color: white;
  margin-bottom: 30px;
  cursor: pointer;
  
  option {
    background: #1a2332;
    color: white;
  }
  
  &:focus {
    outline: none;
    border-color: #fcce00;
    box-shadow: 0 0 0 2px rgba(252, 206, 0, 0.2);
  }
`;

const BuyButton = styled.button<{ disabled: boolean }>`
  width: 100%;
  padding: 18px;
  font-family: 'CocomatPro', sans-serif;
  font-size: 16px;
  font-weight: bold;
  text-transform: uppercase;
  letter-spacing: 1px;
  background: ${props => props.disabled ? 
    'rgba(255, 255, 255, 0.2)' : 
    'linear-gradient(100deg, #fcce00, #f7931e)'};
  color: ${props => props.disabled ? 'rgba(255, 255, 255, 0.5)' : 'white'};
  border: none;
  border-radius: 25px;
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  transition: all 0.2s ease;
  text-shadow: ${props => props.disabled ? 'none' : '2px 2px 4px rgba(0, 0, 0, 0.7)'};
  margin-bottom: 20px;
  
  &:hover {
    transform: ${props => props.disabled ? 'none' : 'translateY(-2px)'};
    box-shadow: ${props => props.disabled ? 'none' : '0 4px 12px rgba(252, 206, 0, 0.4)'};
  }
`;

const SubscriptionModal: React.FC<SubscriptionModalProps> = ({ isOpen, onClose }) => {
  const [selectedClub, setSelectedClub] = useState<string>('');

  const handleClubChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedClub(event.target.value);
  };

  const handleBuyNow = () => {
    if (selectedClub) {
      const club = clubs.find(c => c.name === selectedClub);
      if (club) {
        window.open(club.stripeUrl, '_blank');
      }
    }
  };

  const handleOverlayClick = (event: React.MouseEvent<HTMLDivElement>) => {
    if (event.target === event.currentTarget) {
      onClose();
    }
  };

  return (
    <ModalOverlay isOpen={isOpen} onClick={handleOverlayClick}>
      <ModalContent>
        <CloseButton onClick={onClose}>×</CloseButton>
        <ModalTitle>Selecciona tu club</ModalTitle>
        
        <ClubSelector value={selectedClub} onChange={handleClubChange}>
          <option value="">-- Elige tu club --</option>
          {clubs.map((club) => (
            <option key={club.name} value={club.name}>
              {club.name}
            </option>
          ))}
        </ClubSelector>
        
        <BuyButton 
          disabled={!selectedClub} 
          onClick={handleBuyNow}
        >
          Comprar ahora
        </BuyButton>

        <small className="mt-2">* Recibirás el mail con tus nuevas credenciales en un plazo de 24/48 horas tras la compra</small>
      </ModalContent>
    </ModalOverlay>
  );
};

export default SubscriptionModal;